module.exports = __webpack_public_path__ + "static/media/F5.fc873cbf.webp";